import { GlobalController } from 'src/shared/global/GlobalController'
import SendEmailSms from './SendEmailSms'
const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}
export const routes = [
  {
    path: 'service-order/send-email',
    name:
      'serviceRequest.service-order.send-email',
    component: SendEmailSms,
    beforeEnter: ifAuthenticated,
    props: true,
    meta: {
      fillContainer: true
    }
  }
]
